export default "__VITE_ASSET__S5bnpvEu__"